module.exports = __webpack_public_path__ + "static/media/share-icon-close.bdc218bb.svg";